<mat-card class="example-card">
  @if (isLoading) {
    <div class="loader-container">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  } @else {
    <div class="card-content">
      <div class="header">
        <button class="back-button" (click)="goBack()" mat-button>
          <mat-icon color="primary">arrow_back</mat-icon>
        </button>
        <h3>
          Total Input Search Results for "{{ searchTerm }}":
          <span class="results">{{ totalResults }} Results</span>
        </h3>
        <button
          class="new-search-button"
          (click)="onNewSearchClick()"
          mat-button
          >
          NEW SEARCH
        </button>
      </div>
      <p class="info-text">
        Item search results are restricted to a maximum of 10 most recent
        inspections based on inspection created date
      </p>
      <cotecna-table
        [data]="inspectionInfo"
        [columns]="columns"
        [actions]="actions"
        [hasSelectableColumn]="false"
        [hasActionsTitle]="false"
        (clickRow)="onRowClick($event)"
        dateFormat="short"
        >
      </cotecna-table>
    </div>
  }

</mat-card>
